<template>
    <div v-if="getUserRS.length > 0 && hasPackSocialManager">
      <ubi-panel icon="world" :title="$t('layouts.socialManagment')" :fixedHeight="true">
        <template v-slot:left-column class="template-block">
          <div class="block">
            <div class="block-header">
              <h4>{{ $t("statisticsMeta.networksStatistics") }}</h4>
            </div>
            <div class="block-body" v-loading="getLoadingKPI" :element-loading-text="$t('portals.list.chargementDonnees')">
              <div class="block-body-rs">
                <h3 class="block-body-title">{{ $t("statisticsDBKS.numberEditorial") }}</h3>
                <div class="block-body-stats">
                  <ul>
                    <li><v-icon class="mr-4" style="color: #3b5998;">mdi-facebook</v-icon></li>
                    <li><v-icon class="mr-4" style="color: #C32AA3;">mdi-instagram</v-icon></li>
                    <li><v-icon class="mr-4" style="color: #0077B5;">mdi-linkedin</v-icon></li>
                    <li><v-icon class="mr-4" style="color: #4582E9;">mdi-google-my-business</v-icon></li>
                  </ul>
                  <ul class="block-body-values">
                    <li class="mb-2">{{showValueKpiByMetricAndMedia ('POSTS_ANNONCES_EDITO_DIFFUSEES', 'FACEBOOK_EDITO')}}</li>
                    <li class="mb-2">{{showValueKpiByMetricAndMedia ('POSTS_ANNONCES_EDITO_DIFFUSEES', 'INSTAGRAM_EDITO')}}</li>
                    <li class="mb-2">{{showValueKpiByMetricAndMedia ('POSTS_ANNONCES_EDITO_DIFFUSEES', 'LINKEDIN_EDITO')}}</li>
                    <li class="mb-2">{{showValueKpiByMetricAndMedia ('POSTS_ANNONCES_EDITO_DIFFUSEES', 'GOOGLE_MY_BUSINESS_EDITO')}}</li>
                  </ul>
                </div>
              </div>
              <div class="block-body-rs">
                <h3 class="block-body-title">{{ $t("statisticsDBKS.numberAdsPost") }}</h3>
                <div class="block-body-stats">
                  <ul>
                    <li><v-icon class="mr-4" style="color: #3b5998;">mdi-facebook</v-icon></li>
                    <li><v-icon class="mr-4" style="color: #C32AA3;">mdi-instagram</v-icon></li>
                    <li><v-icon class="mr-4" style="color: #0077B5;">mdi-linkedin</v-icon></li>
                    <li><v-icon class="mr-4" style="color: #4582E9;">mdi-google-my-business</v-icon></li>
                  </ul>
                  <ul class="block-body-values">
                    <li class="mb-2" v-if="universClient === 'IMMO'">{{showValueKpiByMetricAndMedia ('POSTS_ANNONCES_DIFFUSEES', 'FACEBOOK_POST_IMMO')}}</li>
                    <li class="mb-2" v-if="universClient === 'IMMO'">{{showValueKpiByMetricAndMedia ('POSTS_ANNONCES_DIFFUSEES', 'INSTAGRAM_IMMO')}}</li>
                    <li class="mb-2" v-if="universClient === 'IMMO'">{{showValueKpiByMetricAndMedia ('POSTS_ANNONCES_DIFFUSEES', 'LINKEDIN_IMMO')}}</li>
                    <li class="mb-2" v-if="universClient === 'IMMO'">{{showValueKpiByMetricAndMedia ('POSTS_ANNONCES_DIFFUSEES', 'GOOGLE_MY_BUSINESS_IMMO')}}</li>
                    <li class="mb-2" v-if="universClient === 'VO'">{{showValueKpiByMetricAndMedia ('POSTS_ANNONCES_DIFFUSEES', 'FACEBOOK_POST_VO')}}</li>
                    <li class="mb-2" v-if="universClient === 'VO'">{{showValueKpiByMetricAndMedia ('POSTS_ANNONCES_DIFFUSEES', 'INSTAGRAM_VO')}}</li>
                    <li class="mb-2" v-if="universClient === 'VO'">{{showValueKpiByMetricAndMedia ('POSTS_ANNONCES_DIFFUSEES', 'LINKEDIN_VO')}}</li>
                    <li class="mb-2" v-if="universClient === 'VO'">{{showValueKpiByMetricAndMedia ('POSTS_ANNONCES_DIFFUSEES', 'GOOGLE_MY_BUSINESS_VO')}}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:right-column>
          <div v-if="getCodeReseauSfc && getCodeReseauSfc">
            <StatsDBKS />
          </div>
          <div v-else-if="hasLocalSeo">
            <h4>{{ $t("statisticsDBKS.statusOfBroadcasts") }}</h4>
            <p>{{ $t("statisticsDBKS.contentOfBroadcasts")}}</p>
            <div class="container-diffusion-presence-locale">
              <div><img :src="require('@/assets/produits/Illustration-MD-2024.png')" alt="Illustration diffusion" width="150px"/></div>
              <div><el-button type="primary" @click="sendMailPresenceLocale" class="buttonBlockProduit">{{$t('dashboard.beCall') }}</el-button></div>
            </div>
          </div>
        </template>
        <template v-slot:right-column-bottom v-if="hasPackSocialManager" v-loading="getLoadingKpiSM" :element-loading-text="$t('portals.list.chargementDonnees')">
          <div class="block">
            <div class="block-header">
              <h4>TOP <span class="blue-style">3</span> des Meilleurs posts sur vos réseaux sociaux</h4>
            </div>
            <div class="block-body">
              <el-tabs v-model="activeName" @tab-click="handleClickTabs">
                <el-tab-pane label="Facebook" name="Facebook"></el-tab-pane>
                <el-tab-pane label="Instagram" name="Instagram"></el-tab-pane>
                <el-tab-pane label="Linkedin" name="Linkedin"></el-tab-pane>
              </el-tabs>
              <el-table :data="getRanking" style="width: 100%">
                <el-table-column width="320">
                  <template #header>
                    <div class="block-label">
                      <div>Posts</div>
                      <div><img :src="imageStatForPost" alt="Icone RS" width="20px"/></div>
                    </div>
                  </template>
                  <template v-slot="{ row }">
                    <div class="post-item">
                      <div v-if="row.annoncePhotos !== null">
                        <img v-if="!isUserDemo" :src="row.annoncePhotos" class="post-image" width="100"/>
                        <img v-if="isUserDemo" :src="require(`@/assets/fakePictures/${getSitimmoUser.login}/${row.annoncePhotos}`)" class="post-image" width="100"/>
                      </div>
                      <div v-else>
                        <ubi-icon class="no-photo post-image" name="camera" size='50'/>
                      </div>
  
                      <div>
                        <p class="truncate-container"><strong>{{$t('statistics.titleAd')}} : </strong><span class="ranking-title">{{ row.titre }}</span></p>
                        <p class="truncate-container-date"><strong>{{$t('statistics.publishedAt')}} : </strong><span class="date-integration">{{ formattedDate(row.annonceDateDernierDiffusion) }}</span></p>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="Engagement">
                  <template v-slot="{ row }">
                    <div class="engagement">
                      <div class="engagement-item">
                        <div><img :src="require('@/assets/iconsStats/thumb-up.png')" width="10px"/></div>
                        <div>{{ (row.valeur) ? formatNumber(row.valeur) : 0}}</div>
                      </div>
                      <div class="engagement-item">
                        <div><img :src="require('@/assets/iconsStats/comments.png')" width="10px"/></div>
                        <div>{{ (row.nombreCommentaires) ? formatNumber(row.nombreCommentaires) : 0 }}</div>
                      </div>
                      <div class="engagement-item">
                        <div><img :src="require('@/assets/iconsStats/shared.png')" width="10px"/></div>
                        <div>{{ (row.nombrePartages) ? formatNumber(row.nombrePartages) : 0 }}</div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </template>
      </ubi-panel>
    </div>
    <div v-else>
      <ubi-panel>
        <template>
          <CardProduct :image="require('@/assets/produits/Illustration-SM-2024.png')" :title="$t('layouts.socialManagment')" :subtitle="$t('dashboard.titleProduitNonActive')" :content="$t('dashboard.txtProduitNonActiveSocialManagment')" />
        </template>
      </ubi-panel>
    </div>
  </template>
  <script>
  import StatsDBKS from '@/components/StatsDBKS.vue'
  import UbiPanel from '@/components/Panel.vue'
  import UbiIcon from '@/components/Icon.vue'
  import CardProduct from '@/components/ui/CardProduct.vue'
  import { mapGetters } from 'vuex'
  import { sendEmail } from '@/services/email'
  import { formatNumber } from '@/helpers/functions/formatNumber'
  import { TabPane, Tabs } from 'element-ui'
  import { getDiffuseur } from '@/helpers/functions/diffuseur'
  import moment from 'moment'
  
  export default {
    name: 'CardDashboardSM',
    components: {
      CardProduct,
      UbiIcon,
      UbiPanel,
      StatsDBKS,
      ElTabs: Tabs,
      ElTabPane: TabPane
    },
    data () {
      return {
        activeName: 'Facebook',
        imageStatForPost: null
      }
    },
    computed: {
      ...mapGetters(['getUserRS', 'getCodeReseauSfc', 'getSitimmoUser', 'getUniverse', 'isUserDemo', 'hasPackSocialManager']),
      ...mapGetters('productLine', ['hasLocalSeo']),
      ...mapGetters('KPI', [
        'getKpi',
        'getLoadingKPI',
        'getLoadingKpiSM',
        'getRankingFacebook',
        'getRankingInstagram',
        'getRankingLinkedin'
      ]),
      universClient () {
        return this.getSitimmoUser.univers
      },
      getKPI () {
        return this.$store.getters['KPI/getKpi']
      },
      getRanking () {
        if (this.activeName === 'Facebook') {
          return this.getRankingFacebook
        }
        if (this.activeName === 'Instagram') {
          return this.getRankingInstagram
        }
        if (this.activeName === 'Linkedin') {
          return this.getRankingLinkedin
        }
      }
    },
    methods: {
      formatNumber,
      async sendMailPresenceLocale () {
        const sendTo = processEnvConfig.VUE_APP_ADRESSE_MAIL_CONTACT_MARKETING
        const mailData = {
          to: sendTo,
          subject: 'Demande d’information sur le produit : Pack social manager expert - ' + this.getSitimmoUser.login,
          email_content: `L'${this.getSitimmoUser.login} souhaite être recontacté pour en savoir plus sur le produit : Pack social manager expert`
        }
        const repEnvoiMail = await sendEmail(mailData)
        if (repEnvoiMail.type === 'error') {
          this.$message({ message: this.$t('error.found'), type: 'error' })
        } else {
          this.$message({ message: this.$t('dashboard.emailSend'), type: 'success' })
        }
      },
      showValueKpiByMetricAndMedia (metric, media) {
        if ('data' in this.getKPI && this.getKPI.data.length > 0) {
          const resultKPI = this.getKPI.data.filter((kpi) => kpi.metric === metric && kpi.media === media)
          return (resultKPI.length > 0 && resultKPI[0].valeur !== undefined) ? resultKPI[0].valeur : 0
        }
        return 0
      },
      handleClickTabs (tab) {
        switch (tab.name) {
          case 'Instagram':
            this.imageStatForPost = require('@/assets/2048px-Instagram_icon.png')
            break
          case 'Linkedin':
            this.imageStatForPost = require('@/assets/linkedin-logo.png')
            break
          case 'Google':
            this.imageStatForPost = require('@/assets/google-logo-carre.png')
            break
          default:
            this.imageStatForPost = require('@/assets/facebook-logo-5-1.png')
        }
        this.$store.dispatch('KPI/loadKpiSM', { datatype: 'ranking', diffuseur: getDiffuseur(this.activeName, this.getUniverse, false) })
      },
      formattedDate (string) {
        if (!isNaN(string)) {
          return moment.unix(parseInt(string)).format('YYYY-MM-DD')
        }
        if (moment(string, moment.ISO_8601, true).isValid()) return moment(string).format('YYYY-MM-DD')
      }
    },
    mounted () {
      this.$store.dispatch('statisticsDBKS/loadStatsDBKS')
      this.$store.dispatch('KPI/loadKPI')
      this.$store.dispatch('KPI/loadKpiSM', { datatype: 'all', diffuseur: getDiffuseur(this.activeName, this.getUniverse, false) })
      this.activeName = 'Facebook'
      this.imageStatForPost = require('@/assets/facebook-logo-5-1.png')
    }
  }
  </script>
  <style lang="scss" scoped>
  .block {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .block-header {
      padding-top: 0;
      text-align: left;
      flex-shrink: 0;
    }
    .block-body {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
  
      &-title{
        color: #00a4bd;
        text-transform: lowercase;
        font-family: "Dosis", Helvetica, Arial, sans-serif;
        text-align: left;
        &:first-letter{
          text-transform: capitalize;
        }
      }
      &-stats {
        display: flex;
        justify-content: space-between;
        ul{
          text-align: left;
          list-style-type: none;
        }
      }
      &-values {
        list-style-type: none;
        color: #00a4bd;
        font-weight: bold;
      }
  
      &-rs{
        width: 100%;
      }
    }
    .block-footer-link {
      display: inline-block;
      width: 100%;
      text-align: start;
      margin-top: 10px;
      p {
        padding-top: 15px;
        font-family: "Dosis", sans-serif;
      }
    }
  }
  
  .container-diffusion-presence-locale {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px
  }
  
  .stat-link {
    color: #D24554;
    text-decoration: underline;
    font-weight: bold;
    cursor: pointer;
    font-size: 15px;
  }
  
  .chart-container{
    position: relative;
    height: 350px;
    width: 100%;
    margin: 0 auto;
  }
  
  .post-item {
    display: flex;
    justify-content: start;
    align-items: center;
  }
  .post-image {
    width: 70px;
    height: 70px;
    object-fit: cover;
    margin-right: 10px;
  }
  .engagement {
    display: flex;
    font-size: 10px;
    font-weight: bold;
    gap: 10px;
    &-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 18px;
      }
      i {
        font-size: 12px;
        color: #606266;
      }
      span {
        font-size: 12px;
      }
    }
  }
  .el-table::before {
    height: 0;
  }
  .block-label{
    display: flex;
    gap: 5px;
    align-items: center;
  }
  .tooltip-element{
    display: flex;
    margin: 0;
  }
  
  .ranking-title{
    font-size: 14px;
    font-family: "Dosis", Helvetica, Arial, sans-serif;
    display: inline-block;
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
  }
  .truncate-container {
    display: flex;
    strong{
      width: 95px;
    }
  }
  .truncate-container-date {
    strong{
      width: 95px;
    }
  }
  
  .date-integration{
    font-size: 13px;
  }
  </style>
  